import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import cn from 'classnames'
import _ from 'lodash'
import { withRouter, matchPath } from 'react-router'
import { fetchMenuItems, fetchSiteInfo } from '../actions'
import { DEFAULT_MENU } from '../reducers/menu'
import { DEFAULT_SITE_INFO } from '../reducers/siteinfo'
import { DEFAULT_VIDEO_STATE } from '../reducers/video'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'
import { DEFAULT_PAGE } from '../reducers/pages'
import { Logo } from '../images/Logo'
import MetaData from '../components/MetaData'

class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: false,
        }
        this.toggleMenu = this.toggleMenu.bind(this)
        this.closeMenu = this.closeMenu.bind(this)
    }
    componentWillMount() {
        const { fetchMenuItems, fetchSiteInfo } = this.props
        fetchMenuItems()
        fetchSiteInfo()
    }
    toggleMenu() {
        this.setState({
            menuOpen: !this.state.menuOpen
        })
    }
    closeMenu() {
        this.setState({
            menuOpen: false
        })
    }
    render() {
        const { menu, siteInfo, playing, currentPage, location } = this.props
        const navClass = cn('top-nav', {playing: playing, active: this.state.menuOpen})
        return (
            <header>
                <MetaData siteInfo={siteInfo} title={currentPage && (location.pathname === '/' ? 'Home' : currentPage.title.rendered)} meta=""/>
                <nav className={navClass}>
                    <div className="navtitle">
                        <div className='mobile-menu' onClick={this.toggleMenu}><span className="menu-anim"><span></span></span></div>
                        <Link to="/" className="title" onClick={this.closeMenu}><Logo/></Link>
                    </div>
                    <div className="navwrap">
                    {menu.map( (item, i) => 
                        item.classes.join(' ') !== 'highlight' ? 
                        <NavLink onClick={this.closeMenu} key={i} to={`/${item.url.replace( /^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//, '' )}`}>{item.title}</NavLink>
                        :
                        <Link key={i} to='#offerte' className="highlight">{item.title}</Link>
                    )}
                    </div>
                </nav>
		    </header>
		)
    }
}

function mapStateToProps(state, ownProps) {
    const path = ownProps.location.pathname
    const match = matchPath(path, {path: '/:page',exact: true,}) || matchPath(path, {path: '/:page/:slug',exact: true,})  || {params: ''}
    const trainingen = state.customposts['trainingen'] || state.customposts[DEFAULT_CUSTOM_POST]
    const klanten = state.customposts['klanten'] || state.customposts[DEFAULT_CUSTOM_POST]
    const taqtici = state.customposts['taqtici'] || state.customposts[DEFAULT_CUSTOM_POST]
    const thePost = trainingen.find( (item) => item.slug === match.params.slug ) || klanten.find( (item) => item.slug === match.params.slug ) || taqtici.find( (item) => item.slug === match.params.slug ) || state.customposts[DEFAULT_CUSTOM_POST][0]
    const currentPage = (!_.isEmpty(match.params.slug) ? thePost : state.pages[match.params.page]) || state.pages[DEFAULT_PAGE]
    const menu = state.menu.menuItems || state.menu[DEFAULT_MENU]
    const siteInfo = state.siteinfo.siteInfo || state.siteinfo[DEFAULT_SITE_INFO]
    const playing = state.video.playing || state.video[DEFAULT_VIDEO_STATE].playing
    
    return {
        menu: menu,
        siteInfo: siteInfo,
        playing: playing,
        currentPage: currentPage,
    }
}

export default withRouter(connect(mapStateToProps,{ fetchMenuItems, fetchSiteInfo })(Menu))


// WEBPACK FOOTER //
// ./src/containers/Menu.js